export default __webpack_public_path__ + "static/media/25.146e0fde.svg";